import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  FormGroup,
  Label,
  ButtonGroup,
  Button,
  Tooltip,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Constants from '../../services/Constants';
import DocumentsFilter from './documents/DocumentsFilter';
import SimpleTypeahead from '../typeahead/SimpleTypeahead';
import { changeDocumentsViewFilter, saveNewViewModel } from '../../actions';

export const PlansFilter = (props) => {
  const [entityTypeFilter, setEntityTypeFilter] = useState([]);
  const [tooltipGridViewOpen, setTooltipGridViewOpen] = useState(false);
  const [tooltipListViewOpen, setTooltipListViewOpen] = useState(false);

  const toggleGridViewTooltip = () =>
    setTooltipGridViewOpen(!tooltipGridViewOpen);
  const toggleListViewTooltip = () =>
    setTooltipListViewOpen(!tooltipListViewOpen);

  const ALL = Constants.ALL;
  const documentView = props.documentView;
  const filterProperty = [Constants.ENTITY_TYPE];
  const filterLabel = Constants.FILTER_LABELS[filterProperty];

  const [selectedPlan, setSelectedPlan] = useState(
    props.filterPlansBy?.[documentView]?.planName
  );
  const [selectedClient, setSelectedClient] = useState(
    props.filterPlansBy?.[documentView]?.clientName
  );

  const handleFilterSelect = (filter) => {
    setEntityTypeFilter({ ...filter });
    props.changeDocumentsViewFilter(documentView, {
      ...props.filterPlansBy[documentView],
      ...filter,
    });
  };

  const handlePlanSelect = (selected) => {
    setSelectedPlan(selected);
    const filter = {
      ...props.filterPlansBy[documentView],
      [Constants.PLAN_NAME]: [selected],
    };
    props.changeDocumentsViewFilter(documentView, filter);
  };

  const handleClientSelect = (selected) => {
    setSelectedClient(selected);
    const filter = {
      ...props.filterPlansBy[documentView],
      [Constants.CLIENT_NAME]: [selected],
    };
    props.changeDocumentsViewFilter(documentView, filter);
  };

  // eslint-disable-next-line react/prop-types
  const CustomPortfolioOption = ({ innerProps, data }) => (
    <div className="doctype-option" {...innerProps} key={data}>
      {data}
    </div>
  );

  const getAvailablePlans = () => {
    const plans = [];
    plans.push(Constants.ALL);

    if (props.data) {
      props.data.forEach((plan) => {
        if (plan) plans.push(plan.planName);
      });
    }

    return plans;
  };

  const getAvailableClients = () => {
    const clients = new Set();
    clients.add(Constants.ALL);

    if (props.data) {
      props.data.forEach((plan) => {
        if (plan) clients.add(plan.clientName);
      });
    }

    return Array.from(clients);
  };

  const avaliablePlans = getAvailablePlans();
  const avaliableClients = getAvailableClients();

  useEffect(() => {
    setSelectedClient(props.filterPlansBy?.[documentView]?.clientName);
    setSelectedPlan(props.filterPlansBy?.[documentView]?.planName);
  }, [documentView, props.filterPlansBy]);

  const loadPortfoliosOptions = (query, mustSelect = true) => {
    return new Promise((resolve) => {
      const availablePlans = getAvailablePlans();
      if (!query || query.length == 0) {
        resolve(availablePlans);
      }
      const options = _.chain(availablePlans)
        .filter((manager) => {
          return (manager || '').toLowerCase().includes(query.toLowerCase());
        })
        .map((manager) => {
          return manager;
        })
        .value();
      if (options.length === 0 && mustSelect) {
        resolve(avaliablePlans);
      }
      resolve(options);
      handlePlanSelect(query);
    });
  };

  const loadClientsOptions = (query, mustSelect = true) => {
    return new Promise((resolve) => {
      const availableClients = getAvailableClients();
      if (!query || query.length == 0) {
        resolve(availableClients);
      }
      const options = _.chain(availableClients)
        .filter((client) => {
          return (client || '').toLowerCase().includes(query.toLowerCase());
        })
        .map((client) => {
          return client;
        })
        .value();
      if (options.length === 0 && mustSelect) {
        resolve(avaliableClients);
      }
      resolve(options);
      handleClientSelect(query);
    });
  };

  return (
    <div className="filterBy">
      <Row>
        <Col lg={11}>
          <FormGroup className="filters-selects">
            <Label
              className={`${
                filterLabel.class ? `${filterLabel.class}` : 'filters-label'
              }
            `}
              key={`${filterProperty}-label`}
              id={`${filterProperty}-label`}>
              <span>{Constants.FILTER_LABELS[filterProperty].label}</span>
            </Label>
            <DocumentsFilter
              selected={
                entityTypeFilter[filterProperty]?.length > 0
                  ? entityTypeFilter[filterProperty]
                  : ALL
              }
              options={Constants.FILTER_VALUES[filterProperty]}
              filterProperty={filterProperty}
              isMultiSelect={
                Constants.FILTER_LABELS[filterProperty].multiSelect
              }
              hasLoaded={true}
              isLoading={!props.letterFilter && !props.isMyplans}
              inputType={Constants.FILTER_LABELS[filterProperty].inputType}
              onSelect={(filter) => handleFilterSelect(filter)}
              documentView={documentView}
            />
          </FormGroup>
        </Col>
        <Col lg={1}>
          {Boolean(props.documentView === Constants.PLANS_VIEW) && (
            <div className="switchGroup">
              <FormGroup switch disabled>
                <ButtonGroup size="small">
                  <Button
                    id="tiles-view"
                    size="small"
                    className={`${props.portfoliosViewModel ? 'off' : ''}`}
                    onClick={() => props.saveNewViewModel(false)}>
                    <i className="fa-solid fa-border-all"></i>
                  </Button>
                  <Button
                    id="list-view"
                    size="small"
                    className={`${props.portfoliosViewModel ? '' : 'off'}`}
                    onClick={() => props.saveNewViewModel(true)}>
                    <i className="fa-solid fa-list-ul"></i>
                  </Button>
                </ButtonGroup>
              </FormGroup>
              <Tooltip
                isOpen={tooltipGridViewOpen}
                target="tiles-view"
                toggle={toggleGridViewTooltip}>
                Grid View
              </Tooltip>
              <Tooltip
                isOpen={tooltipListViewOpen}
                target="list-view"
                toggle={toggleListViewTooltip}>
                List View
              </Tooltip>
            </div>
          )}
        </Col>
      </Row>
      <div className="filters-dropdowns">
        {Boolean(!props.singleClient) && (
          <FormGroup>
            <Label for="select-client">Client</Label>
            <SimpleTypeahead
              id="select-client"
              options={avaliableClients}
              loadOptions={(e) => loadClientsOptions(e, false)}
              onChange={(e) => handleClientSelect(e)}
              value={selectedClient}
              placeHolder="Select Client"
              customComponents={{
                Option: CustomPortfolioOption,
              }}
              disabled={!props.letterFilter && !props.isMyplans}
              isValid
              alwaysShowOptions
            />
          </FormGroup>
        )}
        <FormGroup>
          <Label for="select-portfolio">Portfolio</Label>
          <SimpleTypeahead
            id="select-portfolio"
            options={avaliablePlans}
            loadOptions={(e) => loadPortfoliosOptions(e, false)}
            onChange={(e) => handlePlanSelect(e)}
            value={selectedPlan}
            placeHolder="Select Portfolio"
            customComponents={{
              Option: CustomPortfolioOption,
            }}
            disabled={!props.letterFilter && !props.isMyplans}
            isValid
            alwaysShowOptions
          />
        </FormGroup>
      </div>
    </div>
  );
};

PlansFilter.propTypes = {
  changeDocumentsViewFilter: PropTypes.func,
  data: PropTypes.array,
  documentView: PropTypes.string.isRequired,
  filterPlansBy: PropTypes.object,
  saveNewViewModel: PropTypes.func,
  portfoliosViewModel: PropTypes.bool,
  isMyplans: PropTypes.bool,
  letterFilter: PropTypes.string,
  singleClient: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    letterFilter: state.ui.letterFilter,
    filterPlansBy: state.ui.filterBy,
    portfoliosViewModel: state.ui.portfoliosViewModel,
  };
};

export default connect(mapStateToProps, {
  changeDocumentsViewFilter,
  saveNewViewModel,
})(PlansFilter);
